import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { Field, FormikErrors, FormikValues } from "formik";
import RadioButton from "../../../shared/publicForms/RadioButton";
import TextField from "../../../shared/publicForms/TextField";
import {
  RadioButtonGroupWrapper,
  RadioButtonGroup,
} from "../../styles/diversity-form-styles";

export interface IEthnicityProps {
  values: {
    ethnicGroup?: null | string;
    ethnicSubgroup?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
}

const Black: FunctionComponent<IEthnicityProps> = ({
  values,
  setFieldValue,
}) => {
  const radioButtonOptions = [
    null,
    "Black - African",
    "Black - Caribbean",
    "Black - Other",
  ];
  const { ethnicSubgroup } = values;

  return (
    <RadioButtonGroupWrapper
      role="group"
      marginTop={22}
      aria-labelledby="ethnicity-radio-group"
    >
      <RadioButtonGroup width={200}>
        {radioButtonOptions
          .filter((option) => option)
          .map((option) =>
            option === "Black - Other" ? (
              <Fragment key={option}>
                <Field
                  name="ethnicSubgroup"
                  type="radio"
                  aria-label={option}
                  label={option}
                  value={option}
                  onChange={() => setFieldValue("ethnicSubgroup", "", true)}
                  checked={!radioButtonOptions.includes(ethnicSubgroup)}
                  as={RadioButton}
                />
                {!radioButtonOptions.includes(ethnicSubgroup) && (
                  <Field
                    name="ethnicSubgroup"
                    type="text"
                    aria-label={ethnicSubgroup}
                    placeholder="Please specify"
                    as={TextField}
                  />
                )}
              </Fragment>
            ) : (
              <Field
                key={option}
                name="ethnicSubgroup"
                type="radio"
                aria-label={option}
                label={option}
                value={option}
                as={RadioButton}
              />
            )
          )}
      </RadioButtonGroup>
    </RadioButtonGroupWrapper>
  );
};

Black.propTypes = {
  values: PropTypes.shape({
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default Black;
